import { useCallback, type ChangeEvent, type ComponentProps } from "react";
import { SearchIcon, XIcon } from "lucide-react";

import { cn } from "@tudigo-monorepo/core-tudigo-theme";

import { ButtonRebrand } from "../rebrand/ui/button-rebrand/button-rebrand";
import { TextInput } from "./form/inputs/text-input/text-input";

interface SearchBarProps extends ComponentProps<"div"> {
  value?: string;
  onSearchChange: (query: string) => void;
  onClear?: () => void;
  placeholder?: string;
}

export const SearchBar = ({
  className,
  value = "",
  onSearchChange,
  onClear,
  placeholder = "Rechercher...",
  ...props
}: SearchBarProps) => {
  const handleSearchChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      onSearchChange(event.currentTarget.value);
    },
    [onSearchChange],
  );

  return (
    <div className={cn("relative w-full md:w-60", className)} {...props}>
      <SearchIcon className="text-dark-2 absolute left-3 top-1/2 z-10 h-5 w-5 -translate-y-1/2 transform" />

      <TextInput
        value={value}
        onChange={handleSearchChange}
        placeholder={placeholder}
        className={cn(
          "ring-light-2 w-full border-0 bg-white py-2 pl-10 pr-10 ring-1 ring-offset-inherit transition-colors",
          value.length > 0 &&
            "bg-accent-super-light-rebrand ring-accent-medium",
        )}
      />

      {value.length > 0 && onClear && (
        <ButtonRebrand
          variant="ghost"
          onClick={onClear}
          className="bg-accent-rebrand absolute right-3 top-1/2 h-6 w-6 -translate-y-1/2 transform p-0"
        >
          <XIcon className="text-accent h-5 w-5" />
          <span className="sr-only">Effacer la recherche</span>
        </ButtonRebrand>
      )}
    </div>
  );
};
